import { styled } from 'styled-system/jsx'

const AvatarRing = styled('div', {
  base: {
    borderRadius: 'pill',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'display',
    fontWeight: '700',
    color: '#FFFFFF',
    letterSpacing: '0.4px',
    boxShadow: '0 6px 14px -8px rgba(128, 84, 255, 0.45)',
    border: '2px solid #FFFFFF',
  },
  variants: {
    size: {
      sm: {
        width: '32px',
        height: '32px',
        fontSize: '12px',
      },
      md: {
        width: '40px',
        height: '40px',
        fontSize: '14px',
      },
      lg: {
        width: '64px',
        height: '64px',
        fontSize: '22px',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export { AvatarRing }
